import {
  Card,
  CardBody,
  Modal,
  ModalHeader
} from 'reactstrap';


const AssessmentViewModal = (props: any) => {
  const { isOpen, toggle, traineeData } = props;

  const getMarks = (assessmentValue: number) => {
    switch (assessmentValue) {
      case 1:
        return 'Poor';
      case 2:
        return 'Good';
      case 3:
        return 'Excellent';
      default:
        return '';
    }
  };


  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>Assesment View</ModalHeader>
      <Card>
        <CardBody>
          <h6 className='block-heading'>Recent Seen Case(Cold)</h6>
          <table className='table table-bordered table-striped table-sm'>
            <thead>
              <tr>
                <th className='col-sm-3'>Case</th>
                <th className='col-sm-3'>Value</th>
                <th className='col-sm-3'>Result</th>
                <th className='col-sm-3'>Comment</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Point of History</td>
                <td>{traineeData?.examiner_assessment?.point_in_history}</td>
                <td>{getMarks(traineeData?.examiner_assessment?.point_in_history_assessment)}</td>
                <td rowSpan={2}>{traineeData?.examiner_assessment?.recently_seen_case_comment}</td>
              </tr>
              <tr>
                <td>Point of Examination</td>
                <td>{traineeData?.examiner_assessment?.point_in_examination}</td>
                <td>{getMarks(traineeData?.examiner_assessment?.point_in_examination_assessment)}</td>
              </tr>
            </tbody>
          </table>
          <h6 className='block-heading'>Emergency Managed</h6>
          <table className='table table-bordered table-striped table-sm'>
            <thead>
              <tr>
                <th className='col-sm-3'>Case</th>
                <th className='col-sm-3'>Value</th>
                <th className='col-sm-3'>Result</th>
                <th className='col-sm-3'>Comment</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Problem</td>
                <td>{traineeData?.examiner_assessment?.problem}</td>
                <td>{getMarks(traineeData?.examiner_assessment?.problem_assessment)}</td>
                <td rowSpan={2}>{traineeData?.examiner_assessment?.emergency_managed_comment}</td>
              </tr>
              <tr>
                <td>How Managed</td>
                <td>{traineeData?.examiner_assessment?.how_managed}</td>
                <td>{getMarks(traineeData?.examiner_assessment?.how_managed_assessment)}</td>
              </tr>
            </tbody>
          </table>
          <h6 className='block-heading'>Procedure</h6>
          <table className='table table-bordered table-striped table-sm'>
            <thead>
              <tr>
                <th className='col-sm-3'>Case</th>
                <th className='col-sm-3'>Value</th>
                <th className='col-sm-3'>Result</th>
                <th className='col-sm-3'>Comment</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Why Done</td>
                <td>{traineeData?.examiner_assessment?.why_done}</td>
                <td>{getMarks(traineeData?.examiner_assessment?.why_done_assessment)}</td>
                <td rowSpan={2}>{traineeData?.examiner_assessment?.procedure_comment}</td>
              </tr>
              <tr>
                <td>How Done</td>
                <td>{traineeData?.examiner_assessment?.how_done}</td>
                <td>{getMarks(traineeData?.examiner_assessment?.how_done_assessment)}</td>
              </tr>
            </tbody>
          </table>

        </CardBody>
      </Card>
    </Modal>
  );
};

export default AssessmentViewModal;
